"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.tabPropTypes = exports["default"] = exports.componentPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var componentPropTypes = _propTypes["default"].shape({
  __typename: _propTypes["default"].string,
  resourceType: _propTypes["default"].string,
  quoteText: _propTypes["default"].string,
  caption: _propTypes["default"].string
});

exports.componentPropTypes = componentPropTypes;

var tabPropTypes = _propTypes["default"].shape({
  type: _propTypes["default"].string,
  label: _propTypes["default"].string,
  components: _propTypes["default"].arrayOf(componentPropTypes)
});

exports.tabPropTypes = tabPropTypes;

var PROP_TYPES = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  tabs: _propTypes["default"].arrayOf(tabPropTypes)
});

var _default = PROP_TYPES;
exports["default"] = _default;